const { isMobile } = require("../../scripts/helpers");

class AttachDocuments {
  constructor() {

    if(document.querySelector('.attach-documents') != null && document.querySelector('.attach-documents') != undefined) {
      this.setEvents();
    }

  }
  
  setEvents() {
    var fileInput = document.getElementById('sendDocuments');
    var fileListDisplay = document.querySelector('.documents__status');

    var fileList = [];
    var renderFileList;

    fileInput.addEventListener('change', function (evnt) {

      if(fileList.length >= 1) {
        fileList.push(fileInput.files[0]);

        renderSingleFileList();
      } else {
        for (var i = 0; i < fileInput.files.length; i++) {
          fileList.push(fileInput.files[i]);
        }

        renderFileList();
      }
    });

    function bytesToSize(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes == 0) return '0 Byte';
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

      var finalValue = Math.round(bytes / Math.pow(1024, i), 2);

      return finalValue + ' ' + sizes[i];
    }

    function animateValue(element, start, end, duration) {
      if (start === end) return;
      var range = end - start;
      var current = start;
      var increment = end > start ? 1 : -1;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = element;
      var timer = setInterval(function () {
        current += increment;
        obj.innerHTML = current + '%';
        if (current == end) {
          clearInterval(timer);
        }
      }, stepTime);
    }

    function simulateWidthAndColorChange(element) {
      let statusBar = element.querySelector('.document-status__bar');
      let message = element.querySelector('.document-status__message');
      let removeElementButton = element.querySelector('[data-key-remove]');

      removeElementButton.addEventListener('click', function() {
        element.remove();

        fileList.splice(element.getAttribute('key'), 1);

      });

      setTimeout(() => {
        statusBar.setAttribute('style', 'width: 20%');
        !element.classList.contains('document-status--uploading') && element.classList.add('document-status--uploading');
        animateValue(message, 0, 20, 400);
      }, 1000);

      setTimeout(() => {
        statusBar.setAttribute('style', 'width: 80%');
        animateValue(message, 20, 80, 400);
      }, 2000);

      setTimeout(() => {
        statusBar.setAttribute('style', 'width: 100%');
        !element.classList.contains('document-status--completed') && element.classList.add('document-status--completed');
        animateValue(message, 80, 100, 400);

        setTimeout(() => {
          message.innerHTML = 'Concluído';
        }, 500);
      }, 3000);
    }

    function renderSingleFileList() {

      if (fileList.length > 0 && fileListDisplay.classList.contains('documents__status--active') == false) {
        fileListDisplay.classList.add('documents__status--active');
      }

      var index = fileList.length - 1;
      var file = fileList[index];

      // let errored = file.size > 2097152 ? true : false; // maior que 2 mb
      let errored = file.size > 3145728 ? true : false; // maior que 3 mb

      let html = `
        <div class="document-status ${errored && 'document-status--errored'}" key="${index}"
        >
          <p class="document-status__header">
            <span>
              ${file.name}
            </span>

            <i class="far fa-trash-alt remove-file" data-key-remove="${index}"></i>
          </p>

          <div class="document-status__body">
            <div class="document-status__bar" style="${errored && 'width: 100%'}
            "></div>
          </div>

          <div class="document-status__footer">
            <p class="document-status__message">
              ${errored ? 'O arquivo excede o tamanho máximo de 3MB' : '0%'}
            </p>

            <p class="document-status__size">
              ${bytesToSize(file.size)}
            </p>
          </div>
        </div>
      `;

      fileListDisplay.insertAdjacentHTML("beforeend", html);

      if(!errored) {
        setTimeout(() => {
          simulateWidthAndColorChange(document.querySelector('.document-status[key="' + index + '"]'));
        }, 200);
      } 
    };

    function renderFileList() {

      if (fileList.length > 0 && fileListDisplay.classList.contains('documents__status--active') == false) {
        fileListDisplay.classList.add('documents__status--active');
      }

      fileList.forEach(function (file, index) {

        // let errored = file.size > 2097152 ? true : false; // maior que 2 mb
        let errored = file.size > 3145728 ? true : false; // maior que 3 mb

        let html = `
          <div class="document-status ${errored && 'document-status--errored'}" key="${index}"
          >
            <p class="document-status__header">
              <span>
                ${file.name}
              </span>

              <i class="far fa-trash-alt remove-file" data-key-remove="${index}"></i>
            </p>

            <div class="document-status__body">
              <div class="document-status__bar" style="${errored && 'width: 100%'}
              "></div>
            </div>

            <div class="document-status__footer">
              <p class="document-status__message">
                ${errored ? 'O arquivo excede o tamanho máximo de 3MB' : '0%'}
              </p>

              <p class="document-status__size">
                ${bytesToSize(file.size)}
              </p>
            </div>
          </div>
        `;

        fileListDisplay.insertAdjacentHTML("beforeend", html);

        if(!errored) {
          setTimeout(() => {
            simulateWidthAndColorChange(document.querySelector('.document-status[key="' + index + '"]'));
          }, 200);
        } 
      });
    };

    if(!isMobile()) {
      let dropArea = document.getElementById('drop');
  
      dropArea.addEventListener('drop', function(e) {
        dropHandler(e);
      });

      dropArea.addEventListener('dragover', function(e) {
        dragOverHandler(e);
      });
    
      function dropHandler(ev) {
      
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();
      
        if (ev.dataTransfer.items) {
          // Use DataTransferItemList interface to access the file(s)
          for (var i = 0; i < ev.dataTransfer.items.length; i++) {
            // If dropped items aren't files, reject them
            if (ev.dataTransfer.items[i].kind === 'file') {
              var file = ev.dataTransfer.items[i].getAsFile();

              fileList.push(file);
              
              renderSingleFileList();

            }
          }
        } else {
          // Use DataTransfer interface to access the file(s)
          for (var i = 0; i < ev.dataTransfer.files.length; i++) {
          }
        }
      }

      function dragOverHandler(ev) {
      
        // Prevent default behavior (Prevent file from being opened)
        ev.preventDefault();
      }
    };
  }


    
}

$(document).ready(function() {
  const attachDocuments = new AttachDocuments();
});
